import styled from 'styled-components'

import { mq, sizes } from '../../theme'
import Icon from '../Icon'
import { WysiwygContainer } from '../WysiwygRenderer/styled'

export const About = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3rem;
`

export const AboutTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & span {
    ${({ theme }) => theme.textStyles.text_bold_16}

    @media ${mq(sizes.desktop)} {
      ${({ theme }) => theme.textStyles.text_bold_condensed_18}
      text-transform: inherit;
    }
  }
`

export const AboutIcon = styled(Icon)`
  display: flex;
  width: 2.1rem;
  height: 3.1rem;
  fill: ${({ theme }) => theme.colors.greenApple};
  color: ${({ theme }) => theme.colors.greenApple};
  margin-right: 1.2rem;
  margin-left: 0.2rem;

  @media ${mq(sizes.desktop)} {
    width: 2.1rem;
    height: 3.1rem;
    margin-left: 0.7rem;
    margin-right: 2.7rem;
  }
`

export const AboutContent = styled(WysiwygContainer)`
  ${({ theme }) => theme.textStyles.text_16}
  border-left: ${({ theme }) => `0.5rem solid ${theme.colors.greenMint}`};
  margin-top: 0.5rem;
  margin-left: 1rem;
  padding-left: 2rem;
  max-width: 100%;

  @media ${mq(sizes.desktop)} {
    margin-top: 1.5rem;
    margin-left: 1.5rem;
    padding-left: 3.5rem;
    max-width: 69rem;
  }
`
